import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-view-single-container',
  templateUrl: './view-single-container.component.html',
  styleUrls: ['./view-single-container.component.scss']
})
export class ViewSingleContainerComponent implements OnInit {
  @Input() value:any;
  @Input() componentConfig:any;
  @Input() options:any;

  formOptions = {};

  constructor() { }

  ngOnInit(): void {
    console.log(this.options);
    this.formOptions["formName"] = this.options.formName;
    this.formOptions["formLocation"] = this.options.formLocation;
    this.formOptions["entityName"] = this.options.entityName;
  }

}
